import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import toastr from "toastr";

import {
    GET_TEAM_ALCOM_SCORES,
    GET_SERVICE_ALCOM_SCORES,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES, GET_MTTA_MTTR_METRICS, GET_MTTA_MTTR_METRICS_FOR_TEAMS
} from "./actionTypes";

import {
    getTeamAlcomScoresSuccess,
    getTeamAlcomScoresFail,
    getServiceAlcomScoresSuccess,
    getServiceAlcomScoresFail,
    getUnmappedResourceAlcomScoresSuccess,
    getUnmappedResourceAlcomScoresFail,
    getMTTAMTTRMetricsSuccess,
    getMTTAMTTRMetricsFail,
    getMTTAMTTRMetricsForTeamsSuccess,
    getMTTAMTTRMetricsForTeamsFail,
} from "./actions";

import {
    getTeamAlcomScoresUrl,
    getServiceAlcomScoresUrl,
    getUnmappedResourceAlcomScoresUrl,
    getMTTAMTTRMetricsUrl,
    getMTTAMTTRMetricsForTeamsUrl
} from "../../helpers/fakebackend_helper";


function* onGetTeamAlcomScores({ payload }) {
    try {
        const response = yield call(getTeamAlcomScoresUrl, {
            team_ids: payload
        });
        yield put(getTeamAlcomScoresSuccess(response));
        toastr.success("Alcom scores fetched successfully");
    } catch (error) {
        yield put(getTeamAlcomScoresFail(error));
        toastr.error("Failed to get team alcom scores");
    }
}

function* onGetServiceAlcomScores({ payload }) {
    try {
        const response = yield call(getServiceAlcomScoresUrl, {
            service_ids: payload
        });
        yield put(getServiceAlcomScoresSuccess(response));
    } catch (error) {
        yield put(getServiceAlcomScoresFail(error));
        toastr.error("Failed to get alcom scores for team's services");
    }
}

function* onGetUnmappedResourceAlcomScores() {
    try {
        const response = yield call(getUnmappedResourceAlcomScoresUrl);
        yield put(getUnmappedResourceAlcomScoresSuccess(response));
    } catch (error) {
        yield put(getUnmappedResourceAlcomScoresFail(error));
        toastr.error("Failed to get alcom scores for unmapped resources");
    }
}

function* onGetMTTAMTTRMetrics({ payload }){
    try{
        const response = yield call(getMTTAMTTRMetricsUrl, payload)
        yield put(getMTTAMTTRMetricsSuccess(response))
    } catch (error) {
        yield put(getMTTAMTTRMetricsFail(error))
    }
}

function* onGetMTTAMTTRMetricsForTeams({ payload }){
    try{
        const response = yield call(getMTTAMTTRMetricsForTeamsUrl, payload)
        yield put(getMTTAMTTRMetricsForTeamsSuccess(response))
    } catch (error) {
        yield put(getMTTAMTTRMetricsForTeamsFail(error))
    }
}


function* alcomScoreDashboardSaga() {
    yield takeEvery(GET_TEAM_ALCOM_SCORES, onGetTeamAlcomScores);
    yield takeEvery(GET_SERVICE_ALCOM_SCORES, onGetServiceAlcomScores);
    yield takeEvery(GET_UNMAPPED_RESOURCE_ALCOM_SCORES, onGetUnmappedResourceAlcomScores);
    yield takeEvery(GET_MTTA_MTTR_METRICS, onGetMTTAMTTRMetrics)
    yield takeEvery(GET_MTTA_MTTR_METRICS_FOR_TEAMS, onGetMTTAMTTRMetricsForTeams)
}

export default alcomScoreDashboardSaga;